import { SearchIcon } from "@/assets/icons";
import { Input } from "@/atoms";
import { strings } from "@/constants";
import { ButtonTypeEnum, InputVariantEnum } from "@/enums";

type StatusFilterType = "all" | "disabled" | "enabled";

const statusFilters: { label: string, value: StatusFilterType }[] = [
    {
        label: strings.admin.filterAll,
        value: "all",
    },
    {
        label: strings.admin.filterEnabled,
        value: "enabled",
    },
    {
        label: strings.admin.filterDisabled,
        value: "disabled",
    },
];

export const CompaniesToolbar = ({
    onSearchChange,
    onStatusChange,
    search,
    statusFilter,
}: {
    onSearchChange: (value: string) => void,
    onStatusChange: (value: StatusFilterType) => void,
    search: string,
    statusFilter: StatusFilterType,
}) => (
    <div
        className="
            flex
            flex-col
            gap-3
            rounded-default
            border
            border-gray-200
            bg-surface
            p-4
            shadow-sm
            md:flex-row
            md:items-center
        "
    >
        <div className="relative flex-1">
            <SearchIcon
                className="
                    absolute
                    top-1/2
                    left-4
                    h-5
                    w-5
                    -translate-y-1/2
                    text-text-secondary
                "
            />
            <Input
                className="pl-12"
                placeholder={strings.admin.searchPlaceholder}
                value={search}
                variant={InputVariantEnum.DEFAULT}
                onChange={({ target }) => onSearchChange(target.value)}
            />
        </div>
        <div
            className="
                flex
                shrink-0
                gap-1
                overflow-x-auto
                rounded-full
                border
                border-gray-200
                bg-gray-50
                p-1
            "
        >
            {statusFilters.map(({
                label,
                value,
            }) => (
                <button
                    key={value}
                    type={ButtonTypeEnum.BUTTON}
                    className={`
                        shrink-0
                        rounded-full
                        px-4
                        py-2
                        text-sm
                        font-medium
                        whitespace-nowrap
                        transition-colors
                        ${statusFilter === value ? "bg-primary text-white" : "text-text-secondary hover:text-primary"}
                    `}
                    onClick={() => onStatusChange(value)}
                >
                    {label}
                </button>
            ))}
        </div>
    </div>
);

export type { StatusFilterType };
